import React from 'react';
import { BROKER_LOGOS } from '../mock';
import { LOAD_BOARDS, BROKERAGES } from '../data/partners';

/**
 * Premium grayscale-style wordmark strip for industry trust signals.
 * No third-party logos used — brand names rendered as clean typographic marks
 * on a dark strip for legal safety.
 */
const TrustedBrokers = () => {
  // Duplicate the array for an infinite marquee
  const loop = [...BROKER_LOGOS, ...BROKER_LOGOS];

  return (
    <section id="trust" data-testid="trusted-brokers-section" className="relative bg-[#0A1628] py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0 circuit-bg-dark opacity-25" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[60%] h-px bg-gradient-to-r from-transparent via-[#D4A24C]/60 to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10">
          <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#D4A24C]">Industry Network</span>
          <h2 className="mt-3 text-2xl md:text-4xl font-extrabold text-white leading-tight">
            Trusted by Top <span className="text-[#2AA8E8]">Brokers</span>, <span className="gold-text">Loadboards</span> & Platforms
          </h2>
          <p className="mt-4 text-sm md:text-base text-white/70">
            We work with the most trusted names in automotive logistics and nationwide transportation networks.
          </p>
        </div>

        {/* Marquee rail */}
        <div className="relative">
          <div className="absolute left-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-r from-[#0A1628] to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-l from-[#0A1628] to-transparent z-10 pointer-events-none" />

          <div className="overflow-hidden">
            <div className="tagline-track flex items-center gap-4 md:gap-6">
              {loop.map((b, i) => (
                <div
                  key={`${b.name}-${i}`}
                  data-testid={`broker-logo-${b.mark.toLowerCase()}`}
                  className="shrink-0 flex items-center gap-3 px-5 md:px-6 py-3.5 md:py-4 rounded-xl border border-white/10 bg-white/[0.03] hover:border-[#D4A24C]/50 hover:bg-white/[0.06] transition-all backdrop-blur-sm"
                >
                  <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-gradient-to-br from-[#2AA8E8]/15 to-[#D4A24C]/10 border border-white/10 flex items-center justify-center">
                    <span className="text-[10px] md:text-xs font-extrabold text-white tracking-wider">{b.mark}</span>
                  </div>
                  <span className="text-sm md:text-base font-bold text-white/90 whitespace-nowrap tracking-tight">
                    {b.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Supporting stats row */}
        <div className="mt-10 md:mt-14 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {[
            { v: `${LOAD_BOARDS.length}`, l: 'Load boards connected' },
            { v: `${BROKERAGES.length}+`, l: 'Brokerage partners' },
            { v: '50 States', l: 'Nationwide coverage' },
            { v: '24/7', l: 'Dispatch support' },
          ].map((s) => (
            <div key={s.l} className="border border-white/10 rounded-xl p-4 md:p-5 bg-white/[0.02] backdrop-blur-sm">
              <div className="text-xl md:text-2xl font-extrabold gold-text">{s.v}</div>
              <div className="text-[11px] md:text-xs text-white/60 mt-1 uppercase tracking-wider font-semibold">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedBrokers;
